import {
	Opportunity,
	OpportunityRequest,
	OpportunityResponse
} from "@/Contracts/Opportunity";

import axios, { AxiosResponse } from "axios";

import { getRequest } from "@/Utils/Service/BackendService";

import {
	ChildEntityHydrationParams,
	getTableQueryFilters,
	includeChildEntities
} from "@/Contracts/Utils";
import { OpportunityInsightsResponse } from "@/Contracts";
import { AssociatedUsersResponse } from "@/Contracts";

const getOpportunitiesUrl = "/v2/opportunities";
const getOpportunityDetailsUrl = "/v2/opportunities/{opportunity_id}";
const getOpportunityInsightsUrl = "v1/marketplace/vendors/partner/:id/insights";

const getAssociatedUsersUrl =
	"/v2/opportunities/{opportunityId}/associated-users";

export const getOpportunities = async (
	opportunityRequest: OpportunityRequest,
	pipelineId?: string
): Promise<OpportunityResponse> => {
	try {
		let queryParams = `limit=${opportunityRequest.limit}`;
		const included_child_entities = includeChildEntities(
			opportunityRequest.included_child_entities
		);
		queryParams = `${queryParams}${
			included_child_entities && included_child_entities.length > 0
				? `&${included_child_entities}`
				: ""
		}`;
		if (opportunityRequest.filters.length > 0) {
			const appliedFilters = getTableQueryFilters(
				opportunityRequest.filters,
				false
			);
			queryParams = `${queryParams}${
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: ""
			}`;
		}
		queryParams = `${queryParams}${
			opportunityRequest.keywords &&
			opportunityRequest.keywords.length > 0
				? `&q=${opportunityRequest.keywords}`
				: ""
		}`;

		if (opportunityRequest.selected_id) {
			queryParams = `${queryParams}${queryParams.length > 0 ? "&" : ""}${
				!!opportunityRequest?.selected_id
					? `selected_id=${opportunityRequest.selected_id}`
					: ""
			}`;
		}
		if (opportunityRequest.use_all_pipelines_flag) {
			queryParams = `${queryParams}${queryParams.length > 0 ? "&" : ""}${
				!!opportunityRequest?.use_all_pipelines_flag
					? `use_all_pipelines_flag=${true}`
					: ""
			}`;
		}

		const response: AxiosResponse<OpportunityResponse> = await axios(
			getRequest(
				`${getOpportunitiesUrl}?${queryParams}${
					pipelineId
						? `&optional_pipeline_id_field=${pipelineId}`
						: ""
				}`,
				null,
				true,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getOpportunityDetails = async (
	opportunityId: string,
	includeBlocks = false
): Promise<Opportunity> => {
	try {
		const includedChildEntities = includeChildEntities(
			new Array<ChildEntityHydrationParams>(
				ChildEntityHydrationParams.ACTIVITIES_ALL,
				ChildEntityHydrationParams.CLIENT_COMPANIES_NAME,
				ChildEntityHydrationParams.DOCUMENTS_ALL,
				ChildEntityHydrationParams.OPPORTUNITY_ACTION_STATUS,
				ChildEntityHydrationParams.CLIENT_COMPANY_SYNC_DATA,
				ChildEntityHydrationParams.VENDORS_ALL,
				...(includeBlocks
					? [ChildEntityHydrationParams.BLOCKS_CURRENT_REVISION]
					: [])
			)
		);
		const url =
			getOpportunityDetailsUrl.replace(
				"{opportunity_id}",
				opportunityId
			) +
			(includedChildEntities && includedChildEntities.length > 0
				? "?" + includedChildEntities
				: "");
		const response: AxiosResponse<Opportunity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getOpportunityInsights = async (
	partnerId: string
): Promise<OpportunityInsightsResponse> => {
	try {
		const response: AxiosResponse<OpportunityInsightsResponse> =
			await axios(
				getRequest(
					getOpportunityInsightsUrl.replace(":id", partnerId),
					null,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
export const getAssociatedUsers = async (
	opportunityId: string
): Promise<AssociatedUsersResponse> => {
	try {
		const response: AxiosResponse<AssociatedUsersResponse> = await axios(
			getRequest(
				getAssociatedUsersUrl.replace("{opportunityId}", opportunityId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
